export enum LocalStorageTypes{
    INSTITUTES = "institutes",
    ACTIVE = "activeList",
    INACTIVE = "inactiveList",
    PROFESSORS = "professors"
}